import React, { Ref } from 'react'

function _IconCleanBroom(props: React.SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 32 32" fill="none" {...props} ref={ref}>
      <path transform="rotate(-180 23 19)" d="M20 18h6v2h-6Z" fill="currentColor"></path>
      <path transform="rotate(-180 27 27)" d="M24 26h6v2h-6Z" fill="currentColor"></path>
      <path transform="rotate(-180 25 23)" d="M22 22h6v2h-6Z" fill="currentColor"></path>
      <path
        d="M17.0029 20a4.8952 4.8952 0 0 0-2.4044-4.1729L22 3l-1.7309-1-7.5758 13.126A5.6988 5.6988 0 0 0 7.45 16.6289C3.7064 20.24 3.9963 28.6821 4.01 29.04a1 1 0 0 0 1 .96h14.9912a1 1 0 0 0 .6-1.8c-3.5397-2.6561-3.5983-8.1463-3.5983-8.2ZM11.93 16.9971A3.11 3.11 0 0 1 15.0041 20c0 .0381.0019.208.0168.4688l-5.8994-2.6236a3.8 3.8 0 0 1 2.8085-.8481ZM15.4494 28A5.2 5.2 0 0 1 14 25h-2a6.4993 6.4993 0 0 0 .9684 3h-2.2233A16.6166 16.6166 0 0 1 10 24H8a17.3424 17.3424 0 0 0 .6652 4H6c.031-1.8364.29-5.8921 1.8027-8.5527l7.533 3.35A13.0253 13.0253 0 0 0 17.5968 28Z"
        fill="currentColor"
      ></path>
      <path id="_Transparent_Rectangle_" d="M0 0h32v32H0Z" fill="none"></path>
    </svg>
  )
}

export const IconCleanBroom = React.forwardRef(_IconCleanBroom)
